import "../../sass/roadmap.scss";
import moon from "../../images/roadmap-moon.png";
import rocket from "../../images/roadmap-rocket.png";
import { wheelOpt, wheelEvent } from "./scrollHandler";


const ResizeSensor = require("css-element-queries/src/ResizeSensor");
const data = require("../../data/roadmap.json");

const DOTS_SIZE = 10;

let rocketOffset = 100;
let isActiveAlreadyRendered = false;

const getElement = (id) => document.getElementById(id);
const getElementHeight = (id) => getElement(id).clientHeight;

const lastHeights = [];

const renderQuarterCircle = (year, quarter, past = false) => `
  <div class="quarter-circle${past ? " past" : ""}">
    <div class="quarter-circle-year">${year}</div>
    <div class="quarter-circle-quarter">Q${quarter}</div>
  </div>  
`;

function renderFirstActive(past){
	if(!isActiveAlreadyRendered && past == false) {
		isActiveAlreadyRendered = true;
		return `<div id="isFirstActive"></div>`;
	} else {
		return ``
	}
};

const renderTextSection = (title, items = [], past) => `
  <div class="text-resp roadmap-title${past ? " past" : ""}">${title}</div>
  ${items
		.map((item) => `<div class="text-resp roadmap-detail">${item}</div>`)
		.join("")}
`;

const renderCol = (data = [], col = 0, past) =>
	data
		.filter((p, i) => i % 2 === col)
		.map(
			(item) => `
  ${renderTextSection(item.title, item.items, past)}
`
		)
		.join("");

const renderDots = (count) => {
	let windowWith = window.innerWidth
	const dot = '<div class="dot"></div>';
	const res = [];
	if(windowWith < 769) {
		count = 2;
	}
	for (let i = 0; i < count; i += 1) {
		res.push(dot);
	}
	return res.join("");
};

const renderTimeline = () => `
  ${data
		.map(
			({ year, quarter, past, data: sections }, i) => `
	 ${renderFirstActive(past)}
      <div class="quarter-row">
          ${renderQuarterCircle(year, quarter, past)}     
      </div>
      <div class="data-row">
          <div id="text-block-left-${i}" class="text-block left">
              ${renderCol(sections, 0, past)}
          </div>
          <div id="dots-${i}" class="dots-block${past ? " past" : ""}"></div>
          <div id="text-block-right-${i}" class="text-block right">
              ${renderCol(sections, 1, past)}
          </div>
      </div>
    `
		)
		.join("")}
`;

const page = `
<div class="root">
    <div class="content">
        <div class="text-resp title">To Infinity & Beyond</div>
        <div class="text-resp description">
            This roadmap outlines milestones, features, partnerships, and other noteworthy components of the Ether Cards ecosystem. This roadmap will feature items from the past as well as the future.
            <br/><br/>
            The further out an item is, the less specific its delivery date will be. Some items will have multiple dependencies, that is, cannot be started or completed until another milestone has been reached. If there is no date assigned next to a milestone, then it indicates that we are unable to refine its delivery date past the quarter.
        </div>
        <div id="moon-container" class="moon-container">
		
            <img src=${moon} class="moon" alt="Moon"/>
			<div  class="rocket2" alt="Rocket" style="background-image:url(${rocket})"/></div>
           
            
		</div>
		<div class="timeline">
			<div class="start-to-scroll" >
				<h3>START</h3>
				<p>TO SCROLL</p>
			</div>
			${renderTimeline()}
			<div class="back-to-top">
				<h3>BACK</h3>
				<p>TO TOP</p>
			</div>
		</div>
		<div class="container disclaimer-container">
			<p>Ether Cards makes no representation, warranty, or undertaking, express or implied, as to the accuracy, reliability, completeness, or reasonableness of the information in this roadmap. Any assumptions, opinions, and details expressed in any Ether Cards blog or community posts constitute Ether Card’s judgment as of the date thereof and are subject to change without notice. Any projections or claims contained in the information are based on a number of assumptions including, but not limited to market conditions and the current status of Ether Cards, and there can be no guarantee that any projected outcomes will be achieved.</p>
		</div>
    </div>
  </div>
`;



data.forEach(() => lastHeights.push(-1));
const k = document.getElementById("roadmap");
k.innerHTML = page;

const resizeCallback = (i) => {
	const newHeight = Math.max(
		getElementHeight(`text-block-left-${i}`),
		getElementHeight(`text-block-right-${i}`)
	);
	if (lastHeights[i] === -1 || lastHeights[i] !== newHeight) {
		if (!Number.isNaN(newHeight)) {
			lastHeights[i] = newHeight;
			document.getElementById(`dots-${i}`).innerHTML = renderDots(
				newHeight / (DOTS_SIZE * 2 - 1)
			);
		}
	}
};

data.forEach((item, i) => {
	new ResizeSensor(jQuery(`#text-block-left-${i}`), () => resizeCallback(i));
	new ResizeSensor(jQuery(`#text-block-right-${i}`), () => resizeCallback(i));
});

// const handleTouch = (e) => {
//   e.preventDefault();
//   const { pageY, radiusY, screenY } = e.changedTouches[0];
//   console.log(screenY);
// };

let animationRan = false;
let scrollDisabled = false;

const $rocket = $("#rocket");
const handleMouseScroll = (e) => {
	const screenCenter = window.innerHeight / 2;
	const elem = document.getElementById("moon-container");
	const height = elem.clientHeight;
	const rocketHeight = getElementHeight("rocket");
	const scrollToMoon = () => {
		window.scrollTo(0, elem.offsetTop - (screenCenter - height / 2));
	};

	if (!animationRan) {
		if (scrollDisabled) {
			e.preventDefault();
			scrollToMoon();
			if (!!e.deltaY) {
				const ratio = rocketHeight / height;
				if (rocketOffset > -(ratio * 100)) {
					const step = (10 * 1.5) / (height / rocketHeight);
					if (e.deltaY > 0) {
						rocketOffset -= step;
					} else if (rocketOffset <= 100) {
						rocketOffset += step;
					}
				} else {
					scrollDisabled = false;
					animationRan = true;
				}
			}
			$rocket.css({ top: `${rocketOffset}%` });
		} else {
			const { top, bottom } = elem.getBoundingClientRect();
			const center = (top + bottom) / 2;
			if (center - 200 < screenCenter) {
				e.preventDefault();
				scrollDisabled = true;
				scrollToMoon();
			}
		}
	}
};

const startToScrollElement = document.querySelector('.start-to-scroll')

startToScrollElement.addEventListener('click', function(){
	const isFirstActiveElement = document.getElementById('isFirstActive');
	let screenPosition = isFirstActiveElement.getBoundingClientRect();
	window.scrollTo({top: screenPosition.top + window.pageYOffset - 80})
	animationRan = true;
})

// window.addEventListener("DOMMouseScroll", handleMouseScroll, false); // older FF
// window.addEventListener(wheelEvent, handleMouseScroll, wheelOpt); // modern desktop
// window.addEventListener('touchmove', handleTouch, wheelOpt); // mobile

$("div.back-to-top").on("click", function (event) {
	$("html, body").animate({ scrollTop: 0 }, 100);
	event.preventDefault();
	return false;
});

const rocket2 = document.querySelector('#moon-container .rocket2');

window.addEventListener('scroll', setRocketValue, false)

function setRocketValue() {
	let offset = window.pageYOffset;
	let scrolledValue = window.innerHeight + offset;
	let windowWith = window.innerWidth;
	let rocketOffsetValue;
	
	const moonContainer = document.getElementById("moon-container");
	const { top, bottom } = moonContainer.getBoundingClientRect();

	
	if (windowWith < 600 && top < scrolledValue - 300) {	
		rocketOffsetValue = (offset - 250)*-1
		
	} else if (windowWith > 601){
		rocketOffsetValue = offset*-1
	}

	rocket2.style.transform = "translateY(" + rocketOffsetValue + "px)";
}

